export const LICENSE_MANAGEMENT_PROMPTS = {
  activation: `
PROCESSUS D'ACTIVATION D'UNE LICENCE :

1. Prérequis :
- Avoir acheté une licence Premium Shopiweb
- Avoir accès à votre boutique Shopify
- Avoir les droits d'administrateur

2. Obtention des identifiants API Shopify :
- Se connecter à l'admin Shopify
- Aller dans "Applications > Paramètres des applications"
- Créer un jeton d'accès privé
- Sélectionner les autorisations : read_themes, write_themes
- Noter la "Clé API secrète" et le "Jeton d'accès"

3. Étapes d'activation :
- Se connecter à Shopiweb Manager
- Cliquer sur "Activer"
- Remplir le formulaire avec :
  * URL de la boutique (format: boutique.myshopify.com)
  * Clé API secrète
  * Jeton d'accès
- Valider l'activation

4. Vérification et support :
- La licence apparaît dans le tableau de bord
- Email de confirmation envoyé
- En cas de problème :
  * Utiliser le bouton "Créer un ticket" dans le menu profil
  * Ou cliquer sur le bouton d'assistance en bas à droite`,

  deactivation: `
PROCESSUS DE DÉSACTIVATION D'UNE LICENCE :

1. Prérequis importants :
- Sauvegarder toutes les personnalisations du thème
- Noter que la désactivation est irréversible
- Vérifier que vous avez les droits d'administrateur
- S'assurer d'avoir les identifiants API corrects

2. Étapes de désactivation :
- Se connecter à Shopiweb Manager
- Accéder à la section "Désactiver"
- Fournir les informations requises :
  * URL de la boutique Shopify
  * Clé API secrète utilisée lors de l'activation
- Confirmer la désactivation

3. Après la désactivation :
- La licence redevient disponible pour une nouvelle activation
- Le thème reste installé mais ne recevra plus de mises à jour
- Les fonctionnalités premium seront désactivées
- Un email de confirmation est envoyé

4. Support disponible :
- Utiliser le bouton "Créer un ticket" dans le menu profil
- Ou cliquer sur le bouton d'assistance en bas à droite
- Sélectionner "Thème Shopiweb Premium" comme produit
- Décrire votre problème en détail`,

  update: `
PROCESSUS DE MISE À JOUR D'UNE LICENCE :

1. Prérequis essentiels :
- Avoir une licence active
- Sauvegarder le thème actuel
- Vérifier la compatibilité avec votre boutique
- Avoir les identifiants API à jour

2. Étapes de mise à jour :
- Se connecter à Shopiweb Manager
- Accéder à la section "Mise à jour"
- Fournir les informations :
  * URL de la boutique Shopify
  * Clé API secrète
- Sélectionner le thème à mettre à jour
- Confirmer la mise à jour

3. Pendant la mise à jour :
- Ne pas modifier le thème
- Attendre la fin du processus
- Vérifier les logs de mise à jour
- S'assurer qu'aucune erreur n'est survenue

4. Après la mise à jour :
- Vérifier le bon fonctionnement du thème
- Tester les nouvelles fonctionnalités
- Reconfigurer si nécessaire

5. Support disponible :
- En cas de problème, utiliser le bouton "Créer un ticket"
- Sélectionner "Thème Shopiweb Premium"
- Décrire précisément les difficultés rencontrées`,

  download: `
PROCESSUS DE TÉLÉCHARGEMENT D'UNE LICENCE :

1. Prérequis essentiels :
- Avoir une licence Premium active
- Être connecté à Shopiweb Manager
- Avoir lu la documentation d'installation
- Vérifier la compatibilité de votre boutique

2. Étapes de téléchargement :
- Se connecter à Shopiweb Manager
- Accéder à la section "Télécharger"
- Accepter les conditions d'utilisation
- Cliquer sur "Télécharger le thème"
- Choisir l'emplacement de sauvegarde

3. Vérification du téléchargement :
- S'assurer que le fichier ZIP est complet
- Vérifier la taille du fichier (~5-10 Mo)
- Confirmer l'extension .zip
- Vérifier l'intégrité du fichier

4. Support disponible :
- En cas de problème, utiliser le bouton "Créer un ticket"
- Sélectionner le produit concerné
- Décrire précisément votre problème
- Notre équipe vous assistera rapidement`
};